import { useFeatureFlags } from 'v2/shared/hooks/use-feature-flags'
import { usePermissions } from 'v2/shared/hooks/use-permissions'
import { RbacModules, RbacPermissionTypes } from 'v2/types/rbac'

// Single source of truth for whether usage reports may render — gates BOTH the /analytics/usage
// routes and the Analytics sidebar's Usage section. Two conditions: the usageReportsEnabled
// kill-switch flag AND report-view RBAC (usage exposes org-wide spend, so it must stay behind the
// reporting permission). The >30d account-age floor was removed.
export const useUsageReportsGate = (): boolean => {
  const { usageReportsEnabled } = useFeatureFlags()
  const { hasPermission } = usePermissions()
  return Boolean(usageReportsEnabled) && hasPermission(RbacModules.report, RbacPermissionTypes.view)
}
